export default __webpack_public_path__ + "static/media/fork.ee8ae776.svg";